export const API_URL = `${import.meta.env.PUBLIC_API_URL}/api`;
export const WS_URL = import.meta.env.PUBLIC_WS_URL;

export const MFE_BLOQUE_AUTH = import.meta.env.PUBLIC_MFE_BLOQUE_AUTH;

export const SENTRY_DSN = import.meta.env.PUBLIC_SENTRY_DSN || '';
export const KPI_METRICS_API_KEY = import.meta.env.PUBLIC_KPI_METRICS_API_KEY;

export const ENABLE_CHAT = import.meta.env.PUBLIC_ENABLE_CHAT === 'true';

export const IS_LOCAL = import.meta.env.DEV;
export const IS_DEV_DEPLOY = import.meta.env.PUBLIC_IS_DEV_DEPLOY === 'true';
export const OAUTH_REDIRECT_URL = IS_LOCAL
  ? 'http://localhost:8080/oauth'
  : IS_DEV_DEPLOY
    ? 'https://copilot-dev.bloque.app/oauth'
    : 'https://copilot.bloque.app/oauth';
